var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_quality_control && _vm.quality_control_view === 'value')?_c('div',{staticClass:"qc-filter-panel"},[(_vm.quality_control_view === 'value')?_c('div',{staticStyle:{"font-size":"30px"}},[_vm._v(" "+_vm._s(_vm.getDeepValue(_vm.openedEvent, _vm.quality_control_event_key))+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }